<template>
  <div>
    <div class="h-container mb-10">
      <h1 class="my-8 text-center text-h2">{{ t['w.basket.merge.title']() }}</h1>

      <div class="flex flex-col md:flex-row">
        <div class="w-full border-border md:border-r md:pr-10">
          <ul>
            <li v-for="(product, index) in loggedInCartItems" :key="`merge-left-product-${index}`" class="flex border-b py-6 md:last:border-0">
              <OnImg :src="product.image" :title="product.title" :alt="product.title" width="104" class="rounded" />
              <div class="ml-4 text-button-m font-medium">{{ product.name }}</div>
            </li>
          </ul>
        </div>
        <div class="flex w-full justify-center md:pl-10">
          <div class="my-10 flex w-full flex-row-reverse justify-center gap-x-6 md:my-0 md:w-auto md:flex-col md:gap-y-6">
            <div class="w-full">
              <Button class="btn-rounded w-full md:w-48" @click="mergeBaskets(0)">{{ t['w.basket.merge.button.keep']() }}</Button>
            </div>

            <div class="w-full">
              <Button class="btn-secondary btn-rounded w-full md:w-48" @click="mergeBaskets(2)">{{ t['w.basket.merge.button.remove']() }}</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '~/components/button/Button.vue'
import OnImg from '~/components/on-img/OnImg.vue'
import type { BasketMergeSuccessResponse } from '~/types/on24-klient'
import * as t from '~/messages'

interface LoggedInCartItems {
  name: string
  title: string
  image: string
}

defineProps<{
  loggedInCartItems: LoggedInCartItems[]
}>()

const emit = defineEmits<{
  merged: []
}>()

const mergeBaskets = (decision: 0 | 2) => {
  $fetch<BasketMergeSuccessResponse>('/api/basket/merge', {
    method: 'POST',
    body: {
      decision,
    },
  }).then(() => {
    emit('merged')
  })
}
</script>
